import { createContext, useContext } from "react";
import type { CollabPeer } from "../../lib/collab";

/** 协同编辑的在线信息，给顶栏（在线头像）和左侧菜单（谁在哪页）用，免得一层层传 props */
export interface CollabCtx {
  peers: CollabPeer[];
  /** 协同连上了没有：连上且没别人时顶栏写「只有你在线」，让人知道这功能是活的 */
  connected: boolean;
  /** 我当前的代理；别人不在这个代理时，悬浮卡写他在哪个代理，左侧菜单的小点只画同代理的 */
  agent: string;
  /** 代理号 → 显示名（「1201 - 东京」） */
  agentLabel: (a0: string) => string;
  /** 跳到某人那里：他的版本、页面、选中的关、滚动位置 */
  jumpTo: (p: CollabPeer) => void;
  /** 正在跟随的人（peer id）；null = 没在跟随 */
  following: string | null;
  setFollowing: (id: string | null) => void;
  /** 画不画别人的鼠标（每人自己的偏好，存在本机）；描格不受影响 */
  showCursors: boolean;
  setShowCursors: (v: boolean) => void;
}
export const CollabContext = createContext<CollabCtx>({ peers: [], connected: false, agent: "", agentLabel: (a0) => a0, jumpTo: () => {}, following: null, setFollowing: () => {}, showCursors: true, setShowCursors: () => {} });
export const useCollabCtx = () => useContext(CollabContext);
